export default __webpack_public_path__ + "static/media/skovstykket-townhouse-6-rooms-03.2e43a9fe.jpg";